import firebase from "firebase/compat/app"; //compat is newer version to use
import 'firebase/compat/firestore'


const firebaseApp = firebase.initializeApp({
    apiKey: "AIzaSyDlMiEbm-z7I5UzyS38JA7DXnc2JodOBQ0",
    authDomain: "tooo-do.firebaseapp.com",
    projectId: "tooo-do",
    storageBucket: "tooo-do.appspot.com",
    messagingSenderId: "337580023012",
    appId: "1:337580023012:web:f2e3e56e9beb5dba47e0f1",
    measurementId: "G-2KQFQ4RKVS"
});

const db = firebaseApp.firestore();

export default db;